
<template>
  <div id="data-list-list-view" class="data-list-container">

    <div class="w-full">
        <vs-row>
          <vs-col vs-w="3">
            <vs-select v-model="bulan">
              <vs-select-item :key="item.angka" :value="item.angka" :text="item.name" v-for="item in filterBulan" />
            </vs-select>
          </vs-col>

          <vs-col vs-w="3" >
            <vs-select
              v-model="str"
              autocomplete
              >
                <vs-select-item :key="itemx.value" :value="itemx.value" :text="itemx.text" v-for="itemx in struktur"/>

            </vs-select>
          </vs-col>
          <vs-col vs-w="3">
            <vs-select v-model="asn">
              <vs-select-item value="true" text="ASN"/>
              <vs-select-item value="false" text="NON ASN"/>
            </vs-select>
          </vs-col>
          <vs-col vs-w="1">
            <vs-button @click="submitFilter()" :disabled="!isFilterTanggal" class="mr-2">Filter</vs-button>
          </vs-col>
          <vs-col vs-w="2">
            <!--
            <template v-if="taskhitungs">
              <vs-button color="primary" type="filled" icon="archive" @click="activePrompt=true" class="mr-4" :disabled="!isFilterTanggal">Export</vs-button>
            </template>
            -->
          </vs-col>
        </vs-row>

    </div>

    <template v-if="taskhitungs">
      <vs-table ref="table" v-model="selected" :data="taskhitungs">

        <template slot="thead">
          <vs-th sort-key="nama">Nama</vs-th>
          <vs-th sort-key="jabatan">Jabatan</vs-th>
          <vs-th>L. P1</vs-th>
          <vs-th>L. P2</vs-th>
          <vs-th>L. P3</vs-th>
          <vs-th>L. P4</vs-th>
          <vs-th>L. P5</vs-th>
          <vs-th>Total Lambat</vs-th>
          <vs-th>PC. P1</vs-th>
          <vs-th>PC. P2</vs-th>
          <vs-th>PC. P3</vs-th>
          <vs-th>PC. P4</vs-th>
          <vs-th>PC. P5</vs-th>
          <vs-th>Total P.Cepat</vs-th>
          <vs-th>Total L & PC</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.nama }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.jabatan }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.lambat_pekan_1 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.lambat_pekan_2 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.lambat_pekan_3 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.lambat_pekan_4 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.lambat_pekan_5 }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.total_lambat }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cepat_pekan_1 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cepat_pekan_2 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cepat_pekan_3 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cepat_pekan_4 }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.cepat_pekan_5 }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.total_cepat }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.total }}</p>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </template>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import hitungModule from '@/stores/rekap/absensi-pegawai.js'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    flatPickr,
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
      publish: false,

      bulan: moment().format("M"),
      str: null,
      asn: 'true',

      config: {
        mode: 'range',
        dateFormat: "m",
      },
      filterBulan: [
        { name : 'Januari', angka : '1' },
        { name : 'Februari', angka : '2' },
        { name : 'Maret', angka : '3' },
        { name : 'April', angka : '4' },
        { name : 'Mei', angka : '5' },
        { name : 'Juni', angka : '6' },
        { name : 'Juli', angka : '7' },
        { name : 'Agustus', angka : '8' },
        { name : 'September', angka : '9' },
        { name : 'Oktober', angka : '10' },
        { name : 'November', angka : '11' },
        { name : 'Desember', angka : '12' }
      ],
      struktur: [],
      filterTanggal: null,

      taskhitungs : null,
      queriedItems : null,

      // Data Sidebar
    }
  },
  computed: {
    isFilterTanggal () {
      return !this.errors.any() && this.bulan && this.str && this.asn
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  methods: {
    getStruktur(){
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/list-struktur', configs)
      .then((response) => {
        let {data} = response.data
        this.struktur = data
      })
      .catch((error) => {
        let data = error.data
        this.struktur = data
      })
    },
    getStatus (status) {
      if (status === 'publish') return 'success'
      if (status === 'inherit')  return 'danger'
      return 'success'
    },
    submitFilter() {
      this.$vs.loading()
      this.taskhitungs = []
      this.loadTask()

      setTimeout(() => {
        this.$vs.loading.close()
        this.taskhitungs = this.$store.state.hitung.taskhitungs
        this.queriedItems = this.$refs.table ? this.$refs.table.queriedResults.length : this.taskhitungs.length
      }, 8000)

    },
    loadTask() {
      let pilihSet = {
        bulan : this.bulan,
        str : this.str,
        asn : this.asn
      }
      this.$store.dispatch('hitung/fetchTaskHitung', pilihSet)
      .catch(error => { 
        this.$vs.notify({
          color  : 'danger',
          text  : error.message,
        })
      })
      this.$vs.loading.close()
    },
  },
  created () {
    if (!hitungModule.isRegistered) {
      this.$store.registerModule('hitung', hitungModule)
      hitungModule.isRegistered = true
    }
  },
  mounted () {
    this.isMounted = true
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    this.getStruktur()
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 10px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 10px !important;
          }
      }
    }

    .vs-table.subtr {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead.subtr{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
